import axios from "axios"

export const Emailcontec = async (parms) => {
    const { email, nombre, movil, direccion, producto, precio, cantidad, id, password, text } = parms
    try {
        // Antes llamaba directo a graph.facebook.com con un Bearer token de la cuenta de
        // WhatsApp Business embebido aca; ahora pasa por nuestro backend.
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/whatsapp/plantilla-bienvenida", {
            movil,
            email,
            password
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        // let { data } = axios.post("https://api.flashchat.chat/backflash/qr_mensaje_external", {
        //     "sessionName": "48_tickets_v20980008000",
        //     "numero": [
        //         ...movil
        //     ],
        //     "mensaje": {
        //         "type": "text",
        //         "text": text,
        //         "url": ""

        //     }
        // })
        return data
    } catch (error) {
        return error
    }
}
/**
     * {
    "phone": "593984040380@s.whatsapp.net",
    "message": "prueba",
    "link": ""
}
     */
export const EnviarmasivoWhastapp = async (parms) => {
    // Antes llamaba directo a whatsapp_qr con la x-api-key embebida aca; ahora pasa por
    // nuestro backend, que guarda esa key en el servidor.
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/whatsapp/enviar", {
            "telefono": parms.phone,
            "mensaje": parms.mensaje,
            "link": parms.link
        },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                }
            }
        )
        return data

    } catch (error) {
        return error

    }
}
export const EnviaWhast = async (parms) => {
    /*
    {
    "user_ids":["593993713942"],
    "message":"Hola buenas tardes",
     "link":"Hola"
    }
    */
    try {
        let { data, status } = await axios.post("https://api.t-ickets.com/backflash/qr_mensaje_external", parms)
        if (status == "200") return true
        return false
    } catch (error) {
        return false
    }
}
export function formatearNumero(numero) {
    const regex = /^\+?593\d{9}$/;
    let dato = String(numero).trim()
    // Comprobar si el número coincide con la expresión regular
    if (regex.test(dato)) {
        return dato.replace("+", "")
    }
    else if (dato.length === 9) {
        return "593" + dato
    } else return undefined;
}

